import fetch from "auth/FetchInterceptor";

const ProductService = {};

ProductService.getProducts = function (page = 1, headers = {}) {
  return fetch({
    url: `/products/?page=${page}`,
    method: "get",
    headers: {
      ...headers,
    },
  });
};

ProductService.getProduct = function (productId, language_id) {
  return fetch({
    url: `/products/${productId}/`,
    method: "get",
    headers: {
      "Language-Id": language_id,
    },
  });
};

ProductService.createProduct = function (product) {
  return fetch({
    url: "/products/",
    method: "post",
    data: product,
  });
};

ProductService.updateProduct = function (data, productId) {
  return fetch({
    url: `/products/${productId}/`,
    method: "put",
    data: data,
  });
};

ProductService.deleteProduct = function (productId) {
  return fetch({
    url: `/products/${productId}/`,
    method: "delete",
  });
};

ProductService.setProductStatus = function (productId, status) {
  return fetch({
    url: `/products/${productId}/update-status/`,
    method: "patch",
    data: { status },
  });
};

ProductService.getOptionsValues = function (languageId) {
  return fetch({
    url: "/option-values/",
    method: "get",
    headers: {
      "Language-Id": languageId,
    },
  });
};

export default ProductService;
